import { useNotificationContext } from "@circle-react-shared/Notifications/NotificationContext";
import { Icon } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";

export const Banner = ({
  tabsContainerWidth,
}: {
  tabsContainerWidth: number;
}) => {
  const { isBannerDismissed: isDismissed, setBannerDismissed: setIsDismissed } =
    useNotificationContext();
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();
  const isNotificationsTabV2Enabled = Boolean(
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled,
  );
  const isAdminOrModerator =
    currentCommunityMember?.is_admin || currentCommunityMember?.is_moderator;

  if (!isNotificationsTabV2Enabled || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  return (
    <div
      className="bg-info-light flex shrink-0 min-h-[52px] items-center gap-4 px-4 py-3 w-full"
      style={{ maxWidth: tabsContainerWidth }}
    >
      <div className="flex min-w-0 flex-1 gap-3 items-start">
        <div className="w-4 mt-2">
          <Icon name="circle-info" size="md" color="info" />
        </div>
        <div className="flex-1">
          <Typography variant="body-sm" className="break-words">
            {isAdminOrModerator
              ? t("notifications.banner.title_for_moderators")
              : t("notifications.banner.title")}
          </Typography>
        </div>
      </div>
      <IconButton
        icon="cross"
        variant="ghost"
        size="sm"
        aria-label={t("notifications.banner.dismiss")}
        onClick={handleDismiss}
      />
    </div>
  );
};
